import { render, staticRenderFns } from "./BrowserHome.vue?vue&type=template&id=53c8c7ea&scoped=true"
import script from "./BrowserHome.vue?vue&type=script&lang=js"
export * from "./BrowserHome.vue?vue&type=script&lang=js"
import style0 from "./BrowserHome.vue?vue&type=style&index=0&id=53c8c7ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c8c7ea",
  null
  
)

export default component.exports